import { useMemo } from 'react'
import Mapbox, { Marker } from 'react-map-gl'
import { DEFAULT_MAP_ZOOM, MAPBOX_TOKEN } from '../utils/constants/mapbox.constants'
import { useUserPreferences } from '../contexts/UserPreferencesContext'
import AgamiMarkerIcon from './AgamiMarkerIcon'

interface SpotPositionBannerProps {
  latitude?: number
  longitude?: number
}

const SpotPositionBanner: React.FC<SpotPositionBannerProps> = ({ latitude, longitude }) => {
  const { mapStyleUrl, apply3DMap } = useUserPreferences()

  const mapboxInitialView = useMemo(
    () =>
      latitude && longitude
        ? { longitude: Number(longitude), latitude: Number(latitude), zoom: DEFAULT_MAP_ZOOM }
        : null,
    [latitude, longitude]
  )

  return (
    mapboxInitialView && (
      <div className="h-full w-full spot-position-banner">
        <Mapbox
          mapboxAccessToken={MAPBOX_TOKEN}
          mapStyle={mapStyleUrl}
          initialViewState={mapboxInitialView}
          attributionControl={false}
          doubleClickZoom={false}
          scrollZoom={false}
          pitchWithRotate={false}
          style={{
            height: '100%',
            width: '100%',
          }}
          terrain={{
            source: 'mapbox-dem',
            exaggeration: apply3DMap ? 1 : 0,
          }}
        >
          {latitude && longitude && (
            <Marker longitude={longitude} latitude={latitude} anchor="center">
              <span>
                <AgamiMarkerIcon />
              </span>
            </Marker>
          )}
        </Mapbox>
      </div>
    )
  )
}

export default SpotPositionBanner
